
//============================//
// PDP variants sticky start //
// function syncSelectedSizeButton() {
//   const checkedInput = document.querySelector(
//     "input.custom-pdp-variant:checked"
//   );

//   if (!checkedInput) return;

//   const variantId = checkedInput.dataset.variantId;

//   document.querySelectorAll(".custom-quick-size-pdp").forEach((btn) => {
//     btn.classList.toggle(
//       "selected",
//       btn.dataset.variantId === variantId
//     );
//   });
// }

// // Initial
// syncSelectedSizeButton();

// // Radio -> Button
// document.addEventListener("change", (e) => {
//   if (!e.target.matches(".custom-pdp-variant")) return;

//   // wait until Prestige finishes replacing the DOM
//   requestAnimationFrame(() => {
//     requestAnimationFrame(syncSelectedSizeButton);
//   });
// });

// // Button -> Radio
// document.addEventListener("click", (e) => {
//   const btn = e.target.closest(".custom-quick-size-pdp");
//   if (!btn) return;

//   e.preventDefault();

//   const input = document.querySelector(
//     `.custom-pdp-variant[data-variant-id="${btn.dataset.variantId}"]`
//   );

//   if (!input) return;

//   input.checked = true;
//   input.dispatchEvent(
//     new Event("change", {
//       bubbles: true,
//     })
//   );
// });

// // Observe DOM changes (Prestige replaces the buttons)
// const observer = new MutationObserver(() => {
//   syncSelectedSizeButton();
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true,
// });

(() => {

  function syncSelectedSizeButton() {

    const checkedInput = document.querySelector(
      "input.custom-pdp-variant:checked"
    );

    if (!checkedInput) return;


    const variantId = checkedInput.dataset.variantId;


    document.querySelectorAll(".custom-quick-size-pdp")
    .forEach((btn) => {

      btn.classList.toggle(
        "selected",
        btn.dataset.variantId === variantId
      );

    });

  }

  // Prevent duplicate initialization
  if (window.customSizeButtonInitialized) {
    syncSelectedSizeButton();
    return;
  }

  window.customSizeButtonInitialized = true;

  // Initial
  syncSelectedSizeButton();

  // Radio -> Button

  document.addEventListener("change", (e) => {

    if (!e.target.matches(".custom-pdp-variant")) return;


    requestAnimationFrame(() => {

      requestAnimationFrame(
        syncSelectedSizeButton
      );

    });

  });

  // Button -> Radio

  document.addEventListener("click", (e) => {

    const btn = e.target.closest(
      ".custom-quick-size-pdp"
    );

    if (!btn) return;
    e.preventDefault();

    const input = document.querySelector(
      `.custom-pdp-variant[data-variant-id="${btn.dataset.variantId}"]`
    );

    if (!input) return;

    input.checked = true;
    input.dispatchEvent(
      new Event("change", {
        bubbles:true
      })
    );


  });
  // Observe DOM changes safely

  window.sizeButtonObserver =
  new MutationObserver(() => {

    syncSelectedSizeButton();

  });

  window.sizeButtonObserver.observe(
    document.body,
    {
      childList:true,
      subtree:true
    }
  );


})();
//==========================//
// PDP variants sticky end //


//==========================//
// PDP artist popup end //
document.addEventListener("click", function (e) {
  const openBtn = e.target.closest(".custom-pdpartist-wrapper");
  const closeBtn = e.target.closest(".artist-popup-closebtn");
  const overlay = document.querySelector(".artist-popup-overlay");
  const popup = document.querySelector(".custom-pdpartist-content");

  // Open popup
  if (openBtn) {
    e.preventDefault();
    popup.classList.add("active");
    overlay.classList.add("active");
    document.body.style.overflow = "hidden";
    return;
  }

  // Close popup
  if (closeBtn || e.target === overlay) {
    popup.classList.remove("active");
    overlay.classList.remove("active");
    document.body.style.overflow = "";
  }
});
//==========================//
// PDP artist popup end //


//==========================//
// Menu search close start //
document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("#predictive-search-form-megamenu");
  if (!form) return;

  const input = form.querySelector('input[name="q"]');
  const clearBtn = form.querySelector(".custom-search-clear");

  function toggleClearButton() {
    clearBtn.hidden = input.value.trim() === "";
  }

  // Initial state
  toggleClearButton();

  // Show/hide while typing
  input.addEventListener("input", toggleClearButton);

  // Clear button click
  clearBtn.addEventListener("click", (e) => {
    e.preventDefault();

    input.value = "";
    form.dispatchEvent(new Event("reset", { bubbles: true }));

    toggleClearButton();
    input.focus();
  });
});
//=========================//
//  Menu search close end //


//=========================//
// PDP sizing chart start //
function initSizeGuide() {
  const interval = setInterval(() => {
    const table = document.querySelector(".esc-size-guide--table");

    if (!table) return;

    clearInterval(interval);

    // Prevent duplicate switch
    if (!document.querySelector(".sizes_mx")) {
      table.insertAdjacentHTML(
        "beforebegin",
        `
        <div class="sizes_mx">
          <div class="filter_size byinch active">Inches</div>
          <div class="filter_size bycm">Centimeters</div>
        </div>
      `
      );
    }

    // Copy content if wrapper exists
    const guide = document.querySelector(".esc-size-guide");
    const wrapper = document.querySelector(".esc22-size-guide--table-wrap");

    if (guide && wrapper) {
      wrapper.innerHTML = guide.innerHTML;
    }

    // Default = Inches
    document.querySelectorAll(".esc-size-guide--col3, .esc-size-guide--col5")
      .forEach(el => el.style.display = "none");

    document.querySelectorAll(".esc-size-guide--col2, .esc-size-guide--col4")
      .forEach(el => el.style.display = "");
  }, 200);
}

document.addEventListener("click", function (e) {

  // Open Size Guide
  if (e.target.closest('div[data-app="eastsideco_sizeGuides"] a')) {
    initSizeGuide();
  }

  // CM
  if (e.target.classList.contains("bycm")) {

    document.querySelector(".bycm")?.classList.add("active");
    document.querySelector(".byinch")?.classList.remove("active");

    document.querySelectorAll(".esc-size-guide--col2, .esc-size-guide--col4")
      .forEach(el => el.style.display = "none");

    document.querySelectorAll(".esc-size-guide--col3, .esc-size-guide--col5")
      .forEach(el => el.style.display = "");
  }

  // Inches
  if (e.target.classList.contains("byinch")) {

    document.querySelector(".byinch")?.classList.add("active");
    document.querySelector(".bycm")?.classList.remove("active");

    document.querySelectorAll(".esc-size-guide--col3, .esc-size-guide--col5")
      .forEach(el => el.style.display = "none");

    document.querySelectorAll(".esc-size-guide--col2, .esc-size-guide--col4")
      .forEach(el => el.style.display = "");
  }

});
document.addEventListener("variant:change", function (e) {
  // give the DOM a tick in case any listener replaces content asynchronously
  requestAnimationFrame(() => {
    if (window.eastsideco_sizeGuides && typeof window.eastsideco_sizeGuides.reinitialize === "function") {
      window.eastsideco_sizeGuides.reinitialize();
    }
  });
});
//=======================//
// PDP sizing chart end //

//====================================//
// Collections infinite loader start //
window.initAjaxinate = function () {

  const productList = document.querySelector("product-list");
  const pagination = document.querySelector("#AjaxinatePagination");

  if (!productList || !pagination) return;

  if (window.ajaxinate) {
    delete window.ajaxinate;
  }

  window.ajaxinate = new Ajaxinate({
    container: "#" + productList.id,
    pagination: "#AjaxinatePagination",
    method: "click"
  });

};

document.addEventListener("DOMContentLoaded", () => {
    initAjaxinate();
});
// Collections infinite loader end //
//================================//


//============================================//
// featured-collections-v2 add-to-cart start //

document.addEventListener("click", function (e) {

  const promoDropdown = e.target.closest(".custom-promo-dropdown");

  if (promoDropdown) {
    e.preventDefault();

    const wrapper = promoDropdown.closest(".fc-v2__cta-wrap");
    const promoContainer = wrapper.querySelector(".custom-promo-container");

    promoDropdown.classList.add("is-hidden");
    promoContainer.classList.add("is-open");

    requestAnimationFrame(() => {
      promoContainer.style.maxHeight = promoContainer.scrollHeight + 100 + "px";
    });

    return;
  }

  const closeBtn = e.target.closest(".promo-close-svg");

  if (closeBtn) {
    e.preventDefault();

    const promoContainer = closeBtn.closest(".custom-promo-container");
    const wrapper = promoContainer.closest(".fc-v2__cta-wrap");
    const promoDropdown = wrapper.querySelector(".custom-promo-dropdown");

    promoContainer.style.maxHeight = "0px";
    promoContainer.classList.remove("is-open");

    promoDropdown.classList.remove("is-hidden");
  }

});


document.addEventListener("click", function (e) {
  const featuredBtn = e.target.closest(".custom-quick-add-btn.available");
  if (!featuredBtn) return;

  e.preventDefault();

  const mainOfferDiv = featuredBtn.closest(".custom-size-list-featured");
  const promoWrapper = mainOfferDiv.parentElement;

  const countDiv = promoWrapper.querySelector(".custom-promo-product");

  // Toggle active state
  if (featuredBtn.classList.contains("is-active")) {
    featuredBtn.classList.remove("is-active");
    countDiv.classList.add("hidden");

    document.querySelectorAll(".free-product-badge").forEach(el => el.remove());
    document.querySelectorAll(".selected-size-badge").forEach(el => el.remove());
    document.querySelectorAll(".lowest-price-card").forEach((card) => {
      card.classList.remove("lowest-price-card");
    });
    return;
  }

  promoWrapper.querySelectorAll(".custom-quick-add-btn.is-active").forEach(btn => btn.classList.remove("is-active"));
  featuredBtn.classList.add("is-active");

  const productIds = featuredBtn.dataset.productIds.split(",");
  const variantIds = featuredBtn.dataset.variantIds.split(",");
  const matchedInputs = [];

  productIds.forEach((productId, index) => {
    const variantId = variantIds[index];
    const input = document.querySelector(
      `.custom-quick-size.available[data-product-id="${productId}"][data-variant-id="${variantId}"]`
    );
    if (input) {
      matchedInputs.push(input);
    }
  });

  document.querySelectorAll(".selected-size-badge").forEach(el => el.remove());
  document.querySelectorAll(".free-product-badge").forEach(el => el.remove());

  let variantName = null;
  let lowestPrice = Infinity;
  let lowestPriceCard = null;
  let lowestPriceVariantId = null;
  let totalPrice = 0;

  matchedInputs.forEach((input) => {
    const productCard = input.closest("product-card");
    variantName = input.dataset.variantName;
    const productCardInner = productCard.querySelector(".product-card__figure");
    const badge = document.createElement("span");
    badge.className = "selected-size-badge";
    badge.textContent = `✓ ${variantName}`;
    productCardInner.appendChild(badge);

    totalPrice += Number(input.dataset.productPrice);

    const prodPrice = parseFloat(
      input.dataset.productPrice.replace(/[^0-9.]/g, "").replace(/,/g, "")
    );

    if (prodPrice < lowestPrice) {
      lowestPrice = prodPrice;
      lowestPriceCard = productCard;
      lowestPriceVariantId = input.dataset.variantId;
    }

  });

  promoWrapper.querySelector(".custom-promo-selected").textContent = variantName;
  
  let discountDiv = promoWrapper.querySelector(".promo-product-discount");
  let totalPromCount = parseInt(promoWrapper.querySelector(".custom-promo-product-total").textContent);
  let selectedCount = parseInt(matchedInputs.length);
  let remainingCount = totalPromCount - selectedCount

  if (remainingCount > 0) {
    promoWrapper.querySelector(".custom-promo-remaining").textContent = remainingCount;
  } else if (remainingCount <= 0) {
    discountDiv.classList.remove("hidden");
    promoWrapper.querySelector(".custom-promo-product-pricing").classList.add("hidden");
  }

  // Exclude the free (lowest-priced) item once the offer is unlocked
  const payablePrice =
    remainingCount <= 0 ? totalPrice - lowestPrice : totalPrice;

  const formattedPrice = new Intl.NumberFormat(Shopify.locale, {
    style: "currency",
    currency: Shopify.currency.active,
  }).format(payablePrice / 100);

  promoWrapper.querySelector(".custom-promo-price").textContent = formattedPrice;

  document.querySelectorAll(".lowest-price-card").forEach((card) => {
    card.classList.remove("lowest-price-card");
  });

  document.querySelectorAll(".lowest-price-card").forEach((card) => {
    card.classList.remove("lowest-price-card");
  });

  if (remainingCount <= 0 && lowestPriceCard) {
    const figure = lowestPriceCard.querySelector(".product-card__figure");

    // Remove the variant badge from the free product
    figure.querySelector(".selected-size-badge")?.remove();

    // Remove existing FREE badge if any
    figure.querySelector(".free-product-badge")?.remove();

    // Add FREE badge
    const freeBadge = document.createElement("span");
    freeBadge.className = "free-product-badge";
    freeBadge.textContent = "FREE";

    figure.appendChild(freeBadge);
  }

  countDiv.classList.remove("hidden");
  promoWrapper.querySelector(".custom-promo-product-count").textContent = matchedInputs.length;
  promoWrapper.querySelector(".custom-promo-count").textContent = matchedInputs.length;
  
  promoWrapper.dataset.matchedVariantIds = matchedInputs
  .map(input => input.dataset.variantId)
  .join(",");

  promoWrapper.dataset.lowestVariantId = lowestPriceVariantId;
  promoWrapper.dataset.offerUnlocked = remainingCount <= 0;

});

document.addEventListener("click", function (e) {
  const addBtn = e.target.closest(".custom-promo-add-btn");
  if (!addBtn) return;

      // Prevent double click
    if (addBtn.classList.contains("is-loading")) return;

    const originalHTML = addBtn.innerHTML;

    addBtn.classList.add("is-loading");
    addBtn.disabled = true;

    addBtn.innerHTML = `
      <span class="btn-spinner"></span>
      Adding...
    `;

  const mainOfferDiv = addBtn.closest(".custom-size-list-featured");

  let variantIds = mainOfferDiv.dataset.matchedVariantIds.split(",");
  const lowestVariantId = mainOfferDiv.dataset.lowestVariantId;
  const offerUnlocked = mainOfferDiv.dataset.offerUnlocked === "true";

  // Exclude the FREE product
  // if (offerUnlocked) {
  //   variantIds = variantIds.filter(id => id !== lowestVariantId);
  // }

  const itemsToAdd = variantIds.map(id => ({
    id: Number(id),
    quantity: 1
  }));

  const formData = {
    items: itemsToAdd // [{ id: 123, quantity: 1 }, { id: 456, quantity: 1 }]
  };

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  })
  .then(data => {

    fetch(`${window.Shopify.routes.root}cart.js`)
      .then(res => res.json())
      .then(cart => {

        // Update cart count
        document.querySelectorAll("cart-dot").forEach(dot => {
          dot.textContent = cart.item_count;
          dot.classList.toggle("is-visible", cart.item_count > 0);
        });

        // Notify your custom components
        document.dispatchEvent(
          new CustomEvent("cart:items-updated", {
            detail: {
              cart
            }
          })
        );

        // Refresh Prestige cart drawer
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true
          })
        );

        // Open drawer
        document.querySelector("li.header__cart-link a")?.click();

        // Optional toast
        const count = formData.items.length;
        showToast(
          `${count} product${count > 1 ? "s" : ""} added to cart`
        );

        addBtn.classList.remove("is-loading");
        addBtn.classList.add("is-success");

        addBtn.innerHTML = `
          ✓ Added
        `;

        setTimeout(() => {
          addBtn.classList.remove("is-success");
          addBtn.disabled = false;
          addBtn.innerHTML = originalHTML;
        }, 1500);

      });

  })
  .catch(error => {
    console.error(error);

    addBtn.classList.remove("is-loading");
    addBtn.disabled = false;
    addBtn.innerHTML = originalHTML;
  });
});
//===========================================//
// featured-collections-v2 add-to-cart end  //


//==========================//
// Quick add to cart start //
const sizeInputs = document.querySelectorAll(".custom-quick-size.available");

// document.addEventListener("click", function (e) {
//   const sizeBtn = e.target.closest(".custom-quick-size.available");

//   if (!sizeBtn) return;

//   e.preventDefault();

//   const productID = sizeBtn.getAttribute("data-product-id");
//   const varID = sizeBtn.getAttribute("data-variant-id");

//   if (varID && productID) {
//     addAndRefreshPrestigeCart(productID, varID, 1);
//   }
// });

function closeCustomSizePopup() {
  const popup = document.getElementById("custom-size-popup");

  if (!popup) return;

  popup.classList.remove("is-open");
  popup.setAttribute("aria-hidden", "true");

  document.body.classList.remove("custom-size-popup-open");

  const popupBody = document.getElementById("custom-size-popup-body");

  if (popupBody) {
    popupBody.innerHTML = "";
  }
}

document.addEventListener("click", function (e) {
  const sizeBtn = e.target.closest(".custom-quick-size.available");

  if (!sizeBtn) return;

  e.preventDefault();

  const productID = sizeBtn.getAttribute("data-product-id");
  const varID = sizeBtn.getAttribute("data-variant-id");

  if (varID && productID) {
    addAndRefreshPrestigeCart(productID, varID, 1);

    // If size button is inside the popup, close popup
    if (sizeBtn.closest("#custom-size-popup")) {
      closeCustomSizePopup();
    }
  }
});


function addAndRefreshPrestigeCart(mainproductID, variantId, quantity = 1) {
  const formData = {
    'items': [{
      'id': variantId,
      'quantity': quantity
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    const addedItem = data.items ? data.items[0] : data;

    const addedProductId = mainproductID;

    // document.dispatchEvent(
    //     new CustomEvent("crosssell:update", {
    //         detail:{
    //             productId: addedProductId
    //         }
    //     })
    // );

    fetch(`${window.Shopify.routes.root}cart.js`)
      .then(res => res.json())
      .then(cart => {

        // Update cart count
        document.querySelectorAll("cart-dot").forEach(dot => {
          dot.textContent = cart.item_count;
          dot.classList.toggle("is-visible", cart.item_count > 0);
        });

        // NEW: notify free-shipping-bar, cart-cross-sell, and any other
        // component listening for cart:change (matches Prestige's own event shape)
        document.dispatchEvent(
          new CustomEvent("cart:items-updated", {
            detail: {
              cart,
              addedProductId
            }
          })
        );

        showToast(`${addedItem.title} added to cart`, () => {

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true
            })
          );

          const cartDrawerButton = document.querySelector("li.header__cart-link a");

          cartDrawerButton?.click();

        });

      });

  })
  .catch(error => {
    console.error('Error adding item to cart:', error);
  });
}

function showToast(message, callback) {
  const toast = document.createElement("div");

  toast.className = "custom-cart-toast";
  toast.textContent = message;

  document.body.appendChild(toast);

  requestAnimationFrame(() => {
    toast.classList.add("show");
  });

  setTimeout(() => {
    toast.classList.remove("show");

    setTimeout(() => {
      toast.remove();

      if (typeof callback === "function") {
        callback();
      }
    }, 300);
  }, 1000);
}
// Quick add to cart start //
//========================//


// Bundle  start //
//========================//
(function () {
  'use strict';

  const BUNDLE_STORAGE_KEY = 'bundle_builder';
  const DEFAULT_BUNDLE = { limit: 0, items: [], active: false };

  let bundle = getBundle();

  // ── Storage helpers ──
  function getBundle() {
    try {
      const stored = JSON.parse(localStorage.getItem(BUNDLE_STORAGE_KEY));
      return stored || { ...DEFAULT_BUNDLE };
    } catch {
      return { ...DEFAULT_BUNDLE };
    }
  }

  function saveBundle(data) {
    localStorage.setItem(BUNDLE_STORAGE_KEY, JSON.stringify(data));
  }

  function clearBundle() {
    localStorage.removeItem(BUNDLE_STORAGE_KEY);
    bundle = { ...DEFAULT_BUNDLE };
  }

  // ── Move bundle builder block next to the height observer ──
  function mountBundleBuilder() {
    const bundleBuilder = document.querySelector('.tabs-content .bundle-builder');
    const heightObserver = document.querySelector(
      '.shopify-section--main-collection height-observer'
    );
    if (bundleBuilder && heightObserver) {
      heightObserver.insertAdjacentElement('afterend', bundleBuilder);
    }
  }

  // ── Copy-code buttons (scoped to this section only) ──

  const checkSvg = `
<svg xmlns="http://www.w3.org/2000/svg"
     width="16"
     height="16"
     viewBox="0 0 24 24"
     fill="none"
     stroke="#16A34A"
     stroke-width="2"
     stroke-linecap="round"
     stroke-linejoin="round">
    <path d="M20 6 9 17l-5-5"></path>
</svg>
`;


  function initCodeCopyButtons() {
    const section = document.querySelector(".bundle-builder");
    if (!section) return;

    section.querySelectorAll(".code-copy-btn").forEach((btn) => {
        btn.addEventListener("click", function () {
            const code = this.dataset.code;

            navigator.clipboard.writeText(code).then(() => {

                // Change button content
                const originalHtml = this.innerHTML;
                this.innerHTML = checkSvg;

                // Show toast
                showDiscountToast("Discount code copied!");

                setTimeout(() => {
                    this.innerHTML = originalHtml;
                }, 3000);

            });
        });
    });
  }

  function showDiscountToast(message) {

    let container = document.querySelector(".custom-toast-container");

    if (!container) {
        container = document.createElement("div");
        container.className = "custom-toast-container";
        document.body.appendChild(container);
    }

    const toast = document.createElement("div");

    toast.className = "custom-toast";
    toast.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg"
             width="20"
             height="20"
             viewBox="0 0 20 20"
             fill="currentColor">
            <path fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                clip-rule="evenodd">
            </path>
        </svg>

        <span>${message}</span>
    `;

    container.appendChild(toast);

    requestAnimationFrame(() => toast.classList.add("show"));

    setTimeout(() => {
        toast.classList.remove("show");

        setTimeout(() => toast.remove(), 300);
    }, 2500);
  }

  // ── Sticky bundle bar toggle (BUILD BUNDLE / EXIT BUNDLE) ──
  function initStickyBundleBar() {
    const stickyBar = document.querySelector('.bundle-sticky-bar');
    const toggleBtn = document.querySelector('.build-bundle');
    const btnText = toggleBtn?.querySelector('span');
    const productGrid = document.querySelector('.collection__main .product-list');

    if (!stickyBar || !toggleBtn || !btnText || !productGrid) return;

    const defaultText = btnText.textContent.trim();

    toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();

      const isActive = stickyBar.classList.toggle('active');
      productGrid.classList.toggle('build-bundle', isActive);

      bundle = getBundle();
      bundle.limit = Number(stickyBar.dataset.bundleLimit) || 0;
      bundle.active = isActive;
      saveBundle(bundle);

      btnText.textContent = isActive ? 'EXIT BUNDLE' : defaultText;

      if (!isActive) {
        clearBundle();
        renderBundle();
      }
    });
  }

  function initBundleAddButton() {
    const bundleBtn = document.querySelector('.bundle-btn');
    if (bundleBtn) bundleBtn.disabled = true;
  }

  // ── Add item when a size is picked in bundle mode ──
  function handleSizeItemClick(e) {
    const sizeBtn = e.target.closest('.size-item');
    if (!sizeBtn) return;

    const productList = document.querySelector('.product-list');
    if (!productList?.classList.contains('build-bundle')) return;
    if (sizeBtn.classList.contains('disabled')) return;

    e.preventDefault();
    e.stopPropagation();

    const productCard = sizeBtn.closest('.product-card, .product-item, .grid__item');

    addBundleItem({
      productId: sizeBtn.dataset.productId || '',
      variantId: sizeBtn.dataset.variantId || '',
      variantName: sizeBtn.dataset.variantName || '',
      price: sizeBtn.dataset.productPrice || '',
      image: productCard?.querySelector('img')?.src || '',
      title:
        productCard
          ?.querySelector('.product-title, .card__heading, .card-title, .title')
          ?.textContent.trim() || '',
    });
  }

  function addBundleItem(item) {
    bundle = getBundle();

    const isFull = bundle.items.length >= bundle.limit;
    const alreadyAdded = bundle.items.some((x) => x.variantId === item.variantId);
    if (isFull || alreadyAdded) return;

    bundle.items.push(item);
    saveBundle(bundle);
    renderBundle();
  }

  function handleRemoveItemClick(e) {
    const removeBtn = e.target.closest('.remove-item');
    if (!removeBtn) return;

    bundle = getBundle();
    bundle.items = bundle.items.filter((item) => item.variantId !== removeBtn.dataset.id);
    saveBundle(bundle);
    renderBundle();
  }

  function renderBundleBox(box, item) {
    box.innerHTML = item
      ? `
        <img src="${item.image}">
        <span class="item-size">${item.variantName}</span>
        <button class="remove-item" data-id="${item.variantId}">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x w-2 h-2 sm:w-2.5 sm:h-2.5"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
        </button>
      `
      : `<div class="bundle-slot"></div>`;
  }

  function renderBundle() {
    bundle = getBundle();

    const boxes = document.querySelectorAll('.bundle-box');
    const dots = document.querySelectorAll('.progress-dot');
    const bundleBtn = document.querySelector('.bundle-btn');
    const progressCount = document.querySelector('.progress-count span');

    boxes.forEach((box, index) => renderBundleBox(box, bundle.items[index]));

    if (progressCount) progressCount.textContent = bundle.items.length;

    dots.forEach((dot, index) => dot.classList.toggle('active', index < bundle.items.length));

    if (bundleBtn) bundleBtn.disabled = bundle.items.length !== bundle.limit;

    document.querySelectorAll('.product-card[data-product-id]').forEach((card) => {
      const isSelected = bundle.items.some((item) => item.productId === card.dataset.productId);
      card.classList.toggle('active', isSelected);
    });
  }

  function resetBundleBarUI() {
    document.querySelector('.bundle-sticky-bar')?.classList.remove('active');
    document.querySelector('.product-list')?.classList.remove('build-bundle');

    const btnText = document.querySelector('.build-bundle span');
    if (btnText) btnText.textContent = 'BUILD BUNDLE';
  }

  function updateCartUI(cart) {
    document.querySelectorAll('cart-dot').forEach((dot) => {
      dot.textContent = cart.item_count;
      dot.classList.toggle('is-visible', cart.item_count > 0);
    });

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.querySelector('li.header__cart-link a')?.click();
  }

  function submitBundleToCart(btn) {
    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: bundle.items.map((item) => ({ id: item.variantId, quantity: 1 })),
      }),
    })
      .then((r) => r.json())
      .then(() => fetch(`${window.Shopify.routes.root}cart.js`))
      .then((r) => r.json())
      .then((cart) => {
        clearBundle();
        renderBundle();
        resetBundleBarUI();
        updateCartUI(cart);
      })
      .catch((err) => {
        console.error('Bundle add-to-cart failed:', err);
      })
      .finally(() => {
        btn.innerHTML = originalHTML;
        btn.disabled = true;
      });
  }

  function initBundleBtnClick() {
    const bundleBtn = document.querySelector('.bundle-btn');
    if (!bundleBtn) return;

    bundleBtn.addEventListener('click', function () {
      if (bundle.items.length !== bundle.limit) return;
      submitBundleToCart(this);
    });
  }

  // ── Restore sticky bar / grid state on page (re)load ──
  function restoreBundleUI() {
    bundle = getBundle();

    const stickyBar = document.querySelector('.bundle-sticky-bar');
    const toggleBtn = document.querySelector('.build-bundle');
    const btnText = toggleBtn?.querySelector('span');
    const productGrid = document.querySelector('.collection__main .product-list');

    if (!stickyBar || !toggleBtn || !btnText || !productGrid) return;

    stickyBar.classList.toggle('active', bundle.active);
    productGrid.classList.toggle('build-bundle', bundle.active);
    btnText.textContent = bundle.active ? 'EXIT BUNDLE' : 'BUILD BUNDLE';
  }

  function init() {
    mountBundleBuilder();
    initCodeCopyButtons();
    initStickyBundleBar();
    initBundleAddButton();
    initBundleBtnClick();

    bundle = getBundle();
    const stickyBar = document.querySelector('.bundle-sticky-bar');
    if (stickyBar) {
      bundle.limit = Number(stickyBar.dataset.bundleLimit) || bundle.limit;
      saveBundle(bundle);
    }

    restoreBundleUI();
    renderBundle();

    document.addEventListener('click', handleSizeItemClick, true);
    document.addEventListener('click', handleRemoveItemClick);
  }

  document.addEventListener('DOMContentLoaded', init);
})();

// Bundle  end //
//========================//